<template>
  <div class="slider-default">
    <div class="bg-line container"></div>
    <div class="slider-header container">
      <div class="title-invisible">
        <h4 class="title white">{{swiperPlayers.title.title}}</h4>
        <app-show-more :info="info" class="orange" :class="info.class"></app-show-more>
      </div>
      <div class="slider-navigation">
        <div class="swiper-pagination" :class="swiperPlayers.title.pagination" slot="pagination"></div>
        <app-swiper-btn :name="swiperPlayers.title"></app-swiper-btn>
      </div>
    </div>
    <div class="slider-overlay">
      <swiper :options="swiperPlayers.option" ref="mySwiper">
        <swiper-slide v-for="item in players" :key="item.id">
          <app-players-card :item="item"></app-players-card>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
const url = process.env.VUE_APP_URL;

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Swiper_button from "@/components/shared/Swiper_button";

import Show_more from "@/components/shared/Show_more";
import PlayersCard from "@/components/shared/Players-card";

export default {
  props: { swiperOptions: Object },
  data() {
    return {
      info: {
        url: "/players",
        text: "SHOW ALL PLAYERS",
        class: "rect",
      },
      swiperPlayers: {
        title: {
          nextEl: "next",
          prevEl: "prev",
          pagination: "player-slider",
          title: "players",
        },
        option: {
          speed: 800,
          slidesPerView: 3,
          spaceBetween: 30,
          direction: "horizontal",
          //loop: true,
          dynamicBullets: true,
          arrows: false,
          pagination: {
            el: ".swiper-pagination.player-slider",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
          },
          navigation: {
            nextEl: ".next",
            prevEl: ".prev",
          },
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          },
        },
      },
    };
  },
  computed: {
    players() {
      return this.$store.getters.players;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    setPlayers() {
      this.axios
        .get(url + "/participants", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setPlayers", payload);
        });
    },
  },
  mounted() {
    this.setPlayers();
  },
  components: {
    swiper,
    swiperSlide,
    "app-swiper-btn": Swiper_button,
    "app-show-more": Show_more,
    "app-players-card": PlayersCard,
  },
};
</script>
<style lang="scss" scoped>
$blue: #15224e;
.slider-default {
  position: relative;
  background-color: $blue;
  padding: 9rem 0 9.5rem;
  @media only screen and (max-width: 768px) {
    padding: 6rem 0 6.5rem;
  }
  & > *:not(.bg-line) {
    position: relative;
    z-index: 2;
  }

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: calc((100vw - 117rem) / 2 + 117rem / 3);
    height: 100%;
    background: linear-gradient(
      270.1deg,
      #0a0736 0.08%,
      rgba(30, 27, 68, 0.864583) 51.53%,
      rgba(38, 34, 98, 0.03) 162.03%
    );
    opacity: 0.3;
    z-index: 1;
    @media only screen and (max-width: 1199px) {
      width: calc((100vw - 105rem) / 2 + 105rem / 3);
    }
    @media only screen and (max-width: 992px) {
      width: calc((100vw - 75rem) / 2 + 75rem / 3);
    }
    @media only screen and (max-width: 768px) {
      width: calc(100% / 3);
    }
    @media only screen and (max-width: 599px) {
      width: 0;
    }
  }
}
.slider-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin-bottom: 5.5rem;
  @media only screen and (max-width: 768px) {
    margin-bottom: 4.5rem;
  }
  @media only screen and (max-width: 650px) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  }
}
.slider-navigation {
  width: calc(117rem / 3);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 2rem;
  .swiper-pagination {
    position: initial;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 2rem;
    width: 100%;
  }
}
.slider-overlay {
  margin-left: calc((100vw - 117rem) / 2);
  padding-right: 7.5rem;
  overflow: hidden;
  @media only screen and (max-width: 1199px) {
    margin-left: calc((100vw - 105rem) / 2);
    padding-right: 5rem;
  }
  @media only screen and (max-width: 992px) {
    margin-left: calc((100vw - 75rem) / 2);
  }
  @media only screen and (max-width: 768px) {
    margin-left: 1.5rem;
  }
}
.swiper-container {
  width: 100%;
  margin-left: 0;
  overflow: visible;
}
.swiper-slide {
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-right: 3rem;
}
</style>